import { ReportViewModel } from './ReportModels';
import { TestResultPlayer } from './test.model';
export class Player {
    
    LifelineScoutingId: string;
    ShootId: number;
    PositionId: number;
    //public virtual PlayersShoot PlayersShoot:
    //public virtual PlayersPosition PlayersPosition { get; set; }
    FirstName: string;
    LastName: string;
    DateOfBirth: Date;
    Weight: number;
    Height: number;
    Nationality: string;
    TownOfBirth: string;
    JerseyNo: number;
    Gender: string;
    CurrentTeamId: string;
    CurrentTeamIconFileName: string;
    DraftedToTeam: string;
    AgentId: string;
    ChangedByUserId: string;
    ChangedDate: Date;
    CurrentTeam: string;
    Division: string;
    TeamIsChecked: boolean;
    PlayerVisibility: string;
    CreatedByOrgId: number;
    EliteProspectsLink: string;
    ProfileImage: string;

    AgeYearsDecimal:number;
}


export class PlayerViewModel {
    LifelineScoutingId: string;
    PlayerId: string;
    LastName: string;
    FirstName: string;
    JerseyNo: number;
    PositionId: number;
    ShootId: number;
    TestResults: TestResultPlayer[];
    Position: PlayerPosition;
    DateOfBirth: Date;
    Height: number;
    Weight: number;
    Nationality: string;

    PlayerPointsCalculated: number;
    PlayersPointsMax: number;
    PlayerNoOfTests: number;
    ProfileNoOfTests: number;
    PlayerPointsAverage: number;

    AgeYearsDecimal: number;

    ProfileImage: string;
    IsFavourite: boolean;
    ReportCount: number;
    NoteCount: number;

}


export class TeamSeasonPlayer{
        TeamId: string;
        SeasonId: string;
        PlayerId: string;
        JerseyNo: string;
        ProfileImage: string;            
        PositionId: string;
        ShootId: string;
        UpdateOptions: TeamSeasonPlayer_UpdateOptions;        
}

export enum TeamSeasonPlayer_UpdateOptions{
    OnlyCurrentTeam = 0,
    AllTeamsThisSeason = 1,
    AllTeamsAllSeasons = 2,

}



export class PlayerPosition
{
    SportId :number;
    PlayerPositionId :number;
    LanguageCode :string;
    Text :string;

}

export class PlayerPositionCheck
{
    SportId :number;
    PlayerPositionId :number;
    LanguageCode :string;
    Text :string;
    Checked: boolean;
    
}


export class PlayerListViewModel{
    LifelineScoutingId: string;
    PlayerId: string;
    Player: Player;
    PlayerView: PlayerViewModel;
    DivisionName: string;
    TeamName: string;
    IsFavourite: boolean;
    Tags: PlayerTagPlayerViewModel[];
    ReportCount: number;
    NoteCount: number;
    Nationality: string;

}

export class PlayerTagPlayerViewModel{
    TagId: string;
    TagText: string;
    Text?: string;
    TagColor: string;
    UserId: string;
    UserLastName: string;
    UserFirstName: string;
    PlayerId: string;
    PlayerLastName: string;
    PlayerFirstName: string;
    OrganizationId: number;
    CreatedDate: Date;
}

export class PlayerTagViewModel{
    TagId: string;
    TagText: string;
    Text?: string;
    TagColor: string;
    PlayerTagsSecurity: PlayerTagSecurity[];
    PlayerTagsLanguage: PlayerTagsLanguage[];
}

export class PlayerTagsLanguage
{
    TagId: string;
    LanguageId: string;
    Text: string;

}

export class PlayerTagSecurity{
    TagId: string;
    UserId: string;
    LastName: string;
    FirstName: string;
    Addable: boolean;
    Viewable: boolean;
}



export class PlayerDetailsViewModel
{
    Player:  Player;
    DivisionName: string;
    TeamName: string;
    TeamIconFile: string;
    //Teams: PlayerTeam[] ;
    //TeamsOrg: PlayerTeam[] ;
    Reports: ReportViewModel[];
    //Tags: PlayerTagsViewModel[];
    //Agent: Agent ;
    NoOfReports: number;
    NoOfNotes: number;

    IsFavourite: boolean;

    PlayerAgeYears: number;
    PlayerAgeMonths: number;
    PlayerAgeDays: number;
}

export class PlayerContactModel
{
    OrganizationId: number;
    PlayerId: string;
    ContactId: number;
    Relation: string;
    FirstName: string;
    LastName: string;
    CompanyName: string;
    Email: string;
    WorkPhone: string;
    MobilePhone: string;
    HomePhone: string;

    Addresses: PlayerContactAddressModel[];

}

export class PlayerContactAddressModel
{
    OrganizationId: number;
    PlayerId: string;
    ContactId: number;
    AddressId: number;
    AddressType: string;
    Address1: string;
    Address2: string;
    Address3: string;
    PostCode: string;
    City: string;
    State_Province_County: string;
    Country: string;

}